import { getEmptyChart } from './baseChartUtils'
import { getFullChartOptions } from './baseBloodPressureChart'

export default function getBloodPressureChartOptions ({
  memberObj, dashboardViewStore,
  showMemberAlerts, handleAlertClick
}) {
  if (!memberObj.blood_pressure) return getEmptyChart()

  return getFullChartOptions(memberObj, dashboardViewStore, showMemberAlerts,
    handleAlertClick)
}
